export const accountSummaryMockResponse = [
    {
        id: 4,
        name: 'syncreon America, Inc.',
        type: 'Parent',
        status: 'Active',
        deactivationDate: 0,
        accountKeys: [],
        instances: [],
        creditPools: [],
        contractSummary: {
            minStartDate: 17206,
            maxEndDate: 18639,
            totalCreditsPurchased: '20.00000000000',
            totalCreditsAvailable: '20.00000000000',
            totalCreditsConsumed: '0.00000000000',
            totalCreditsExpired: '0.00000000000',
            totalCreditsTransferred: '0.00000000000',
            totalRemainingCredits: '60.00000000000',
            activeContract: {
                id: 6000,
                creditPoolId: 4,
                startDay: 18274,
                endDay: parseInt(`${new Date().valueOf() / (60 * 60 * 24 * 1000)}`, 10) + 10,
                sourceSystem: 'Salesforce',
                sourceId: '0063800000s9f61AAA',
                contractType: 'Term Consumption',
                percentOfCarryover: '0.00',
                archiveTier: 1,
                deactivationDate: 0,
                creditDetails: {
                    accountId: 4,
                    contractId: 6000,
                    allowedToTransferTo: false,
                    allowedToTransferFrom: false,
                    active: true,
                    expired: true,
                    percentOfCarryover: 0,
                    carryoverPercentage: 0,
                    totalCreditsPurchased: '60.00000000000',
                    totalCreditsAvailable: '60.00000000000',
                    totalCreditsAvailableForRollover: '12.00000000000',
                    totalCreditsUsed: '0.00000000000',
                    totalCreditsExpired: '0.00000000000',
                    totalCreditsTransferred: '0.00000000000',
                    totalCreditsTransferredIn: '0.00000000000',
                    totalCreditsToExpire: '413.00000000000',
                    totalCreditsToTransfer: '0.00000000000',
                    totalRemainingCreditsToExpire: '413.00000000000',
                    totalRemainingCreditsToTransfer: '0.00000000000',
                    totalRemainingCredits: '413.00000000000',
                    totalCreditsOfUsage: '0.00000000000',
                    totalCreditsTransferredOut: '0.00000000000',
                },
                contractLineItems: [
                    {
                        id: 6052,
                        startDay: 18274,
                        endDay: 18639,
                        localCurrency: 'USD',
                        localCurrencyConversionRate: '1.00000000',
                        localUnitPrice: '180.0000',
                        unitPrice: '180.0000',
                        productGroup: 'Phoenix',
                        sourceSystem: 'Salesforce',
                        sourceId: '00k3800000cLNsUAAW',
                        orderNumber: 'SO1006534_DM',
                        factorId: 1,
                        factorTableName: 'Factor Table V1 (2019-11-04)',
                        creditDetails: {
                            contractId: 6000,
                            contractLineItemId: 6052,
                            creditsPurchased: '60.00000000000',
                            creditsAvailable: '60.00000000000',
                            creditsAvailableForRollover: '0.00000000000',
                            creditsUsed: '0.00000000000',
                            creditsExpired: '0.00000000000',
                            creditsTransferred: '0.00000000000',
                            creditsTransferredIn: '0.00000000000',
                            creditsToExpire: '60.00000000000',
                            creditsToTransfer: '0.00000000000',
                            remainingCreditsToExpire: '60.00000000000',
                            remainingCreditsToTransfer: '0.00000000000',
                            remainingCredits: '60.00000000000',
                            creditsOfUsage: '0.00000000000',
                            creditsTransferredOut: '0.00000000000',
                        },
                    },
                ],
            },
        },
    },
];
